import * as Yup from 'yup';

const emptyStringToNull = (value, originalValue) =>
  originalValue === '' || originalValue === null || originalValue === undefined
    ? null
    : Number(originalValue);

export default Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
  description: Yup.string().nullable(),
  customerProfile: Yup.number().nullable(),
  categories: Yup.array().nullable(),
  products: Yup.array().nullable(),
  services: Yup.array().nullable(),
  discountType: Yup.string().nullable(),
  percentage: Yup.number()
    .transform(emptyStringToNull)
    .nullable()
    .min(0, 'Inválido')
    .max(100, 'Máximo 100%'),
  discount: Yup.number()
    .transform(emptyStringToNull)
    .nullable()
    .min(0, 'Inválido'),
  minValue: Yup.number().transform(emptyStringToNull).nullable().min(0, 'Inválido'),
  maxDiscount: Yup.number().transform(emptyStringToNull).nullable().min(0, 'Inválido'),
  startDate: Yup.string().nullable(),
  endDate: Yup.string()
    .nullable()
    .test('is-after-start', 'A data de término deve ser posterior à data de início', function (value) {
      const { startDate } = this.parent;
      if (!startDate || !value) return true;
      return new Date(value) > new Date(startDate);
    }),
  usageLimit: Yup.number().transform(emptyStringToNull).nullable().min(1, 'Mínimo de 1 uso'),
  minQuantity: Yup.number().transform(emptyStringToNull).nullable().min(1, 'Mínimo de 1 item'),
  catalogPublication: Yup.string().nullable(),
  couponCode: Yup.string().nullable().when('catalogPublication', {
    is: 'coupon',
    then: Yup.string().required('Informe o código do cupom'),
  }),
  paymentMethods: Yup.array().nullable(),
});


